import React from "react";
import { Container, Table } from "react-bootstrap";

const InvestorGrievanceTable = () => {
  const contactDetails = [
    {
      type: "Customer care",
      name: "Sanjay Baid",
      address:
        "Unit No. 503B, Tower A, 5th Floor of WTC, Zone-5, Gift City, Gandhi Nagar, Gujarat, India, 382355",
      contactNo: "9311786335",
      email: "algoquantglobal@gmail.com",
      workingHours: "Mon-Sat; 9:00 AM to 6:00 PM",
    },
    {
      type: "Head of Customer care",
      name: "Sanjay Baid",
      address:
        "Unit No. 503B, Tower A, 5th Floor of WTC, Zone-5, Gift City, Gandhi Nagar, Gujarat, India, 382355",
      contactNo: "9311786335",
      email: "algoquantglobal@gmail.com",
      workingHours: "Mon-Sat; 9:00 AM to 6:00 PM",
    },
    {
      type: "Compliance Officer",
      name: "Sanjay Baid",
      address:
        "Unit No. 503B, Tower A, 5th Floor of WTC, Zone-5, Gift City, Gandhi Nagar, Gujarat, India, 382355",
      contactNo: "9311786324",
      email: "algoquantglobal@gmail.com",
      workingHours: "Mon-Sat; 9:00 AM to 6:00 PM",
    },
    {
      type: "Director",
      name: "Sanjay Baid",
      address:
        "Unit No. 503B, Tower A, 5th Floor of WTC, Zone-5, Gift City, Gandhi Nagar, Gujarat, India, 382355",
      contactNo: "9311786347",
      email: "algoquantglobal@gmail.com",
      workingHours: "Mon-Sat; 9:00 AM to 6:00 PM",
    },
    {
      type: "Director",
      name: "Mohd Amir Baqui",
      address:
        "Unit No. 503B, Tower A, 5th Floor of WTC, Zone-5, Gift City, Gandhi Nagar, Gujarat, India, 382355",
      contactNo: "9311786329",
      email: "algoquantglobal@gmail.com",
      workingHours: "Mon-Sat; 9:00 AM to 6:00 PM",
    },
  ];

  return (
    <>
      <Container className="investroGrievance paragraphforall">
        <div className="EscalationTableContainer">
        <Table spellCheck frame draggable striped bordered hover className="scrollOnSmall">
          <thead>
            <tr>
              <th>#</th>
              <th>Contact Type</th>
              <th>Contact Name</th>
              <th>Address</th>
              <th>Contact No.</th>
              <th>Email</th>
              <th>Working Hours</th>
            </tr>
          </thead>
          <tbody>
            {contactDetails.map((contact, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{contact.type}</td>
                <td>{contact.name}</td>
                <td>{contact.address}</td>
                <td>{contact.contactNo}</td>
                <td>{contact.email}</td>
                <td>{contact.workingHours}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
        <p className="disc">
          In absence of response/complaint not addressed to your satisfaction,
          you may lodge a complaint with SEBI at{" "}
          <a
            href="https://scores.gov.in/scores/Welcome.html"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "#3fb9ea" }}
          >
            https://scores.gov.in/scores/Welcome.html
          </a>{" "}
          or Exchange at{" "}
          <a
            href="https://www.msei.in/Investors/Introduction"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "#3fb9ea" }}
          >
            https://www.msei.in/Investors/Introduction
          </a>
          .
        </p>
      </Container>
    </>
  );
};

export default InvestorGrievanceTable;
